
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    HIGH: "HIGH",
    MHIGH: "MHIGH",
    MED: "MED",
    MLOW: "MLOW",
    LOW: "LOW"
};
